﻿import * as paths from './paths';
export default class ThematicConfigurator {
    constructor(configContainer, rootURL, settings, resourcesHandler, additional) {
        this.resourcesHandler = resourcesHandler;
        this.configContainer = configContainer;
        this.rootURL = rootURL;
        this.settings = settings;
        this.entityId = 'entity-id';
        this.entityFieldId = 'entity-field-id';
        this.colorPickersId = 'color-pickers-id';
        this.opacityId = 'opacity-id';
        this.strokeWidthId = 'stroke-width-id';
        this.labelTemplateId = 'label-template-id';
        this.thematicTypeId = 'thematic-type-id';
        this.methodId = 'thematic-method-id';
        this.modeId = 'thematic-mode-id';
        this.graduatedSectionId = 'thematic-graduated-section';
        this.categorizedSectionId = 'thematic-categorized-section';
        this.categoryContainerId = 'thematic-category-container';
        this.categoryInnerId = 'thematic-category-inner';
        this.loadCategoriesButtonId = 'thematic-load-categories';
        this.randomizeColorsButtonId = 'thematic-randomize-colors';
        this.colorRampWrapperId = 'color-ramp-wrapper-id';
        this.colorIntervalWrapperId = 'color-interval-wrapper-id';
        this.valueAutoId = 'value-auto-id';
        this.colorRampContainerId = 'color-ramp-container-id';
        this.numberOfRampsId = 'number-of-ramps-id';
        this.generateRampButton = 'generate-ramp-button';
        this.colorIntervalContainerId = 'color-interval-container';
        this.colorIntervalContainerInnerId = 'color-interval-container-inner';
        this.additional = additional;
    }

    save() {
        let mode = $('#' + this.modeId).data('kendoDropDownList').value();

        let ramps = [];

        let rampInputs = $('.ramp-color');

        for (let i = 0; i < rampInputs.length; i++) {
            ramps.push(rampInputs[i].value);
        }

        let intervals = [];

        if (mode == 'CATEGORIZED') {
            // clasificare categoriala: valoare (din data-value, neafectata de editarea etichetei) + eticheta + culoare
            let categoryRows = $('.category-row');

            for (let i = 0; i < categoryRows.length; i++) {
                let categoryRow = $(categoryRows[i]);
                intervals.push({
                    value: categoryRow.attr('data-value'),
                    label: categoryRow.find('.category-label').val(),
                    color: categoryRow.find('.category-color').val()
                });
            }
        } else {
            let createdIntervals = $('.interval-row');

            for (let i = 0; i < createdIntervals.length; i++) {
                let createdInterval = $(createdIntervals[i]);
                let min = createdInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value();
                let max = createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value();
                let color = createdInterval.find('.interval-color').val();

                intervals.push({
                    min: min,
                    max: max,
                    color: color
                });
            }
        }

        let autoValues = $('#' + this.valueAutoId).data('kendoSwitch').check();

        return {
            IdEntity: $('#' + this.entityId).data("kendoComboBox").value(),
            IdEntityField: $('#' + this.entityFieldId).data('kendoComboBox').value(),
            NameEntityField: $('#' + this.entityFieldId).data('kendoComboBox').text(),
            Opacity: $("#" + this.opacityId).data('kendoNumericTextBox').value(),
            StrokeWidth: $("#" + this.strokeWidthId).data('kendoNumericTextBox').value(),
            LabelTemplate: $('#' + this.labelTemplateId).val(),
            AutoValues: mode == 'CATEGORIZED' ? false : autoValues,
            Ramp: ramps,
            Intervals: intervals,
            Type: 'TEMATIC',
            Mode: mode,
            // categorial => CATEGORIZED; valori manuale => MANUAL; altfel metoda aleasa (EQUAL/QUANTILE/JENKS/STDDEV)
            Method: mode == 'CATEGORIZED' ? 'CATEGORIZED' : (autoValues ? ($('#' + this.methodId).data('kendoDropDownList').value() || 'EQUAL') : 'MANUAL'),
            ClassCount: intervals.length
        };
    }

    init() {
        this.configContainer.innerHTML = this._getTemplate();

        if (this.additional == null || this.additional.idEntity == null) {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return this.rootURL + paths.MAP_ENTITY_LAYERS;
                            }
                        }
                    }
                },
                change: (evt) => {
                    $('#' + this.entityFieldId).data("kendoComboBox").value(null);
                    $('#' + this.entityFieldId).data("kendoComboBox").dataSource.read();
                    // categoriile incarcate apartin vechiului camp/entitate => le invalidam
                    this._clearCategories();
                }
            });

            if (this.settings.IdEntity) {
                $('#' + this.entityId).data("kendoComboBox").value(this.settings.IdEntity);
            }
        } else {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: []
            });

            $('#' + this.entityId).data("kendoComboBox").value(this.additional.idEntity);
            $('#id-entity-wrapper').hide();
        }

        if (this.additional == null || this.additional.fields == null) {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                // pe categorial includem si campurile text (widget daca exista, altfel settings la init)
                                let modeWidget = $('#' + this.modeId).data('kendoDropDownList');
                                let categorized = modeWidget != null ? modeWidget.value() == 'CATEGORIZED' : this.settings.Mode == 'CATEGORIZED';
                                return this.rootURL + paths.MAP_ENTITY_GET_STATISTICAL_FIELDS + $('#' + this.entityId).data('kendoComboBox').value() + (categorized ? '&includeText=true' : '');
                            }
                        }
                    }
                },
                change: () => {
                    // schimbarea campului invalideaza categoriile deja incarcate (apartin altui camp)
                    this._clearCategories();
                    this._applyFieldTypeConstraints();
                },
                dataBound: () => {
                    this._applyFieldTypeConstraints();
                }
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        } else {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: this.additional.fields,
                change: () => {
                    this._clearCategories();
                    this._applyFieldTypeConstraints();
                }
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        }

        $("#" + this.opacityId).kendoNumericTextBox({
            min: 0,
            max: 1,
            appendTo: '#' + this.opacityId
        });

        if (this.settings.Opacity != null) {
            $("#" + this.opacityId).data('kendoNumericTextBox').value(this.settings.Opacity);
        } else {
            $("#" + this.opacityId).data('kendoNumericTextBox').value(1);
        }

        $("#" + this.strokeWidthId).kendoNumericTextBox({
            min: 0,
            decimals: 2,
            format: '0.##',
            appendTo: '#' + this.strokeWidthId
        });

        if (this.settings.StrokeWidth != null) {
            $("#" + this.strokeWidthId).data('kendoNumericTextBox').value(this.settings.StrokeWidth);
        } else {
            $("#" + this.strokeWidthId).data('kendoNumericTextBox').value(1);
        }

        $('#' + this.labelTemplateId).val(this.settings.LabelTemplate != null ? this.settings.LabelTemplate : '');

        $('#' + this.methodId).kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            popup: {
                appendTo: $(this.configContainer)
            },
            dataSource: [
                { text: this.resourcesHandler.get('MethodEqual'), value: 'EQUAL' },
                { text: this.resourcesHandler.get('MethodQuantile'), value: 'QUANTILE' },
                { text: this.resourcesHandler.get('MethodJenks'), value: 'JENKS' },
                { text: this.resourcesHandler.get('MethodStdDev'), value: 'STDDEV' }
            ]
        });

        $('#' + this.methodId).data('kendoDropDownList').value(this.settings.Method != null && this.settings.Method !== 'MANUAL' ? this.settings.Method : 'EQUAL');

        $('#' + this.valueAutoId).kendoSwitch({
            messages: {
                checked: this.resourcesHandler.get('SWITCH_ON'),
                unchecked: this.resourcesHandler.get('SWITCH_OFF')
            },
            checked: this.settings.AutoValues == null ? true : this.settings.AutoValues,
            change: evt => {
                if (evt.sender.check()) {
                    $('.interval-input').hide();
                    $('.interval-row').removeClass('col-12');
                    $('.add-interval-wrapper').removeClass('col-12');
                    $('#color-interval-container-inner').removeClass('pl-0');
                    $('#color-interval-container-inner').addClass('pl-1');
                    $('.remove-interval-color-id').css('margin-left', '1.4rem');
                    $($('.remove-interval-color-id')[0]).css('margin-left', '0.75rem');
                    $('.add-interval-color-id').css('margin-left', '0.9rem');
                } else {
                    $('.interval-input').show();
                    $('.interval-row').addClass('col-12');
                    $('.add-interval-wrapper').addClass('col-12');
                    $('#color-interval-container-inner').addClass('pl-0');
                    $('#color-interval-container-inner').removeClass('pl-1');
                    $('.remove-interval-color-id').css('margin-left', '0.75rem');
                    $($('.remove-interval-color-id')[0]).css('margin-left', '0.75rem');
                    $('.add-interval-color-id').css('margin-left', '0.75rem');
                }
            }
        });

        if (this.settings.Ramp == null || this.settings.Ramp.length == 0) {
            this.settings.Ramp = ['#00FF00', '#FFFF00'];
        }

        let template = `<label class="form-label pt-2">` + this.resourcesHandler.get('InputColorIntervals') + `:</label>`;

        for (let i = 0; i < this.settings.Ramp.length; i++) {
            template += `<div class="mb-3 d-flex pt-1">
                <i class="fal fa-times remove-color-id" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: 0.75rem;"></i>
                <input class="ramp-color custom-color" type="color" value="` + this.settings.Ramp[i] + `">
            </div>`;
        }

        template += `<i class="fal fa-plus add-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: green; font-size: 0.9rem; margin-left: 0.5rem;">
                    </i>
                    <div class="col-1 mb-3">
                        <div class="form-group">
                            <input class="form-control" id="` + this.numberOfRampsId + `" placeholder="` + this.resourcesHandler.get('NumberOfRamps') + `">
                        </div>
                    </div>
                    <button id="` + this.generateRampButton + `" class="btn btn-primary" style="height: 2.25rem;">` + this.resourcesHandler.get('Generate') + `</button>`;

        $('#' + this.colorRampContainerId)[0].innerHTML = template;

        $('#' + this.colorRampContainerId).on('click', evt => {
            if (evt.target.classList.contains('add-color-id')) {
                let template = `<div class="mb-3 d-flex pt-1">
                                    <i class="fal fa-times remove-color-id" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: 0.75rem;"></i>
                                    <input class="ramp-color custom-color" type="color" value="#ffffff">
                                </div>`;

                $($(evt.target).parent().children()[$(evt.target).parent().children().length - 4]).after(template);

                $("#" + this.numberOfRampsId).data('kendoNumericTextBox').min($('.ramp-color').length);

                if ($("#" + this.numberOfRampsId).data('kendoNumericTextBox').value() < $('.ramp-color').length) {
                    $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value($('.ramp-color').length);
                }
            } else if (evt.target.classList.contains('remove-color-id')) {
                $(evt.target).parent().remove();
                $("#" + this.numberOfRampsId).data('kendoNumericTextBox').min($('.ramp-color').length);

                if ($("#" + this.numberOfRampsId).data('kendoNumericTextBox').value() < $('.ramp-color').length) {
                    $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value($('.ramp-color').length);
                }
            }
        });

        $("#" + this.numberOfRampsId).kendoNumericTextBox({
            format: "0",
            decimals: 0,
            min: this.settings.Ramp.length
        });

        $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value(this.settings.Ramp.length);

        $('#' + this.generateRampButton).on('click', () => {
            let colors = [];

            let colorInputs = $('.ramp-color');

            for (let i = 0; i < colorInputs.length; i++) {
                colors.push(colorInputs[i].value);
            }

            let intervals = this._generateIntervals(colors, $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value());
            this._setIntervals(intervals, !$('#' + this.valueAutoId).data('kendoSwitch').check());
        });

        if (this.settings.Mode == 'CATEGORIZED') {
            if (this.settings.Intervals != null && this.settings.Intervals.length > 0) {
                this._setCategories(this.settings.Intervals);
            }
        } else if (this.settings.Intervals != null && this.settings.Intervals.length > 0) {
            this._setIntervals(this.settings.Intervals, !$('#' + this.valueAutoId).data('kendoSwitch').check());
        }

        $('#' + this.modeId).kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            popup: {
                appendTo: $(this.configContainer)
            },
            dataSource: [
                { text: this.resourcesHandler.get('ModeGraduated'), value: 'GRADUATED' },
                { text: this.resourcesHandler.get('ModeCategorized'), value: 'CATEGORIZED' }
            ],
            change: () => {
                this._toggleMode(true);
            }
        });

        $('#' + this.modeId).data('kendoDropDownList').value(this.settings.Mode == 'CATEGORIZED' ? 'CATEGORIZED' : 'GRADUATED');

        $('#' + this.loadCategoriesButtonId).on('click', () => {
            this._loadCategories();
        });

        $('#' + this.randomizeColorsButtonId).on('click', () => {
            this._randomizeCategoryColors();
        });

        this._toggleMode(false);
        this._applyFieldTypeConstraints();
    }

    // metodele graduale (cuantile/jenks/stddev) se aplica doar pe campuri numerice;
    // pentru campuri ne-numerice fortam EQUAL si dezactivam selectorul de metoda
    _applyFieldTypeConstraints() {
        let methodWidget = $('#' + this.methodId).data('kendoDropDownList');
        if (methodWidget == null) {
            return;
        }

        let fieldCombo = $('#' + this.entityFieldId).data('kendoComboBox');
        let item = fieldCombo != null ? fieldCombo.dataItem() : null;
        let dataType = item != null ? item.DataType : null;

        // restrictionam doar cand tipul e cunoscut si ne-numeric (nu blocam contextul fara DataType)
        let nonNumericKnown = dataType != null && dataType !== '' && dataType !== 'INTEGER' && dataType !== 'NUMERIC';

        if (nonNumericKnown) {
            methodWidget.value('EQUAL');
            methodWidget.enable(false);
        } else {
            methodWidget.enable(true);
        }
    }

    _toggleMode(reReadFields) {
        let mode = $('#' + this.modeId).data('kendoDropDownList').value();

        if (mode == 'CATEGORIZED') {
            $('#' + this.graduatedSectionId).hide();
            $('#' + this.categorizedSectionId).show();
        } else {
            $('#' + this.categorizedSectionId).hide();
            $('#' + this.graduatedSectionId).show();
        }

        // schimbarea modului schimba lista de campuri eligibile (text doar pe categorial)
        if (reReadFields) {
            let fieldCombo = $('#' + this.entityFieldId).data('kendoComboBox');
            if (fieldCombo != null) {
                fieldCombo.dataSource.read();
            }
        }
    }

    _loadCategories() {
        let idEntity = $('#' + this.entityId).data('kendoComboBox').value();
        let fieldName = $('#' + this.entityFieldId).data('kendoComboBox').text();

        if (idEntity == null || idEntity === '' || fieldName == null || fieldName === '') {
            return;
        }

        $.ajax({
            type: 'GET',
            url: this.rootURL + paths.GET_FIELD_DISTINCT.replaceAll('{0}', idEntity).replaceAll('{1}', encodeURIComponent(fieldName)).replaceAll('{2}', 50),
            async: true,
            contentType: 'application/json; charset=utf-8',
            success: (result) => {
                if (result != null && result.Values != null) {
                    let categories = result.Values.map((v, i) => ({ value: v.Value, label: v.Value, color: this._paletteColor(i) }));
                    this._setCategories(categories);

                    if (result.Truncated && typeof toastr !== 'undefined') {
                        toastr.info(this.resourcesHandler.get('CategoriesTruncated'));
                    }
                }
            },
            error: () => { }
        });
    }

    _setCategories(categories) {
        let template = `<label class="form-label">` + this.resourcesHandler.get('Categories') + `:</label>
                        <div class="form-row ml-0 mt-1 col-12 pl-0 pr-0" id="` + this.categoryInnerId + `">`;

        for (let i = 0; i < categories.length; i++) {
            let cat = categories[i];
            let value = cat.value != null ? cat.value : '';
            let label = cat.label != null ? cat.label : value;
            let color = cat.color != null ? cat.color : '#ffffff';

            template += `<div class="form-row col-12 category-row" data-value="` + this._escapeAttr(value) + `">
                            <input class="category-color mt-1 custom-color" type="color" value="` + this._escapeAttr(color) + `">
                            <div class="form-group col-4 mb-2 pl-1">
                                <input class="category-value form-control" readonly value="` + this._escapeAttr(value) + `">
                            </div>
                            <div class="form-group col-4 mb-2">
                                <input class="category-label form-control" placeholder="` + this.resourcesHandler.get('LabelTemplate') + `" value="` + this._escapeAttr(label) + `">
                            </div>
                            <i class="fal fa-times remove-category-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: 0.75rem;"></i>
                        </div>`;
        }

        template += `</div>`;

        $('#' + this.categoryContainerId)[0].innerHTML = template;

        $('#' + this.categoryInnerId).on('click', (evt) => {
            if (evt.target.classList.contains('remove-category-id')) {
                $(evt.target).parent().remove();
            }
        });
    }

    _clearCategories() {
        let container = document.getElementById(this.categoryContainerId);
        if (container != null) {
            container.innerHTML = '';
        }
    }

    _randomizeCategoryColors() {
        let colorInputs = $('.category-color');

        for (let i = 0; i < colorInputs.length; i++) {
            colorInputs[i].value = this._randomColor();
        }
    }

    _paletteColor(index) {
        let palette = [
            '#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f', '#edc948', '#b07aa1', '#ff9da7', '#9c755f', '#bab0ac',
            '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'
        ];
        return palette[((index % palette.length) + palette.length) % palette.length];
    }

    _randomColor() {
        let n = Math.floor(Math.random() * 0x1000000);
        return '#' + n.toString(16).padStart(6, '0');
    }

    _escapeAttr(value) {
        return String(value).replaceAll('&', '&amp;').replaceAll('"', '&quot;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
    }

    _setIntervals(intervals, showInputs) {
        let template = `<label class="form-label">` + this.resourcesHandler.get('RampColorIntervals') + `:</label>
                        <div class="form-row ml-0 mt-1 col-12` + (showInputs ? ` pl-0` : ` pl-1`) + ` pr-0" id="` + this.colorIntervalContainerInnerId + `">`;
        for (let i = 0; i < intervals.length; i++) {
            template += `<div class="form-row` + (showInputs ? ` col-12` : ``) + ` interval-row">
                            <i class="fal fa-times remove-interval-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: ` + (showInputs || i == 0 ? `0.75rem` : `1.4rem`) + `;"></i>
                            <input class="interval-color mt-1 custom-color" type="color" value="` + intervals[i].color + `">
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? ``: ` style="display: none;"`) + `>
                                <input class="interval-min form-control" placeholder="min">
                            </div>
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? `` : ` style="display: none;"`) + `>
                                <input class="interval-max form-control" placeholder="max">
                            </div>
                        </div>`;
        }

        template += `<div class="form-row` + (showInputs ? ` col-12` : ``) + ` add-interval-wrapper">
                        <i class="fal fa-plus add-interval-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: green; font-size: 0.9rem; margin-right: 1.65rem; margin-left: ` + (showInputs ? `0.75rem` : `1.1rem`) + `;"></i>
                    </div>`;

        template += `</div>`;

        $('#' + this.colorIntervalContainerId)[0].innerHTML = template;

        let createdIntervals = $('.interval-row');

        for (let i = 0; i < createdIntervals.length; i++) {
            let createdInterval = $(createdIntervals[i]);

            createdInterval.find('.interval-min').kendoNumericTextBox({});

            if (createdInterval.min != null) {
                createdInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value(createdInterval.min);
            }

            createdInterval.find('.interval-max').kendoNumericTextBox({});

            if (createdInterval.max != null) {
                createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value(createdInterval.max);
            }

            if (i == 0) {
                createdInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                createdInterval.find('input.interval-min').attr('placeholder', 'auto');
            }

            if (i == createdIntervals.length - 1) {
                createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                createdInterval.find('input.interval-max').attr('placeholder', 'auto');
            }
        }

        $('#' + this.colorIntervalContainerInnerId).on('click', (evt) => {
            if (evt.target.classList.contains('remove-interval-color-id')) {
                $($(evt.target).parent()).remove();

                let remainingIntervals = $('.interval-row');

                for (let i = 0; i < remainingIntervals.length; i++) {
                    let remainingInterval = $(remainingIntervals[i]);

                    if (i == 0) {
                        remainingInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                        remainingInterval.find('input.interval-min').attr('placeholder', 'auto');
                    }

                    if (i == remainingIntervals.length - 1) {
                        remainingInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                        remainingInterval.find('input.interval-max').attr('placeholder', 'auto');
                    }
                }

            } else if (evt.target.classList.contains('add-interval-color-id')) {
                let intervalRowTemplate = `<div class="form-row` + (showInputs ? ` col-12` : ``) + ` interval-row">
                            <i class="fal fa-times remove-interval-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: ` + (showInputs ? `0.75rem` : `1.4rem`) + `;"></i>
                            <input class="interval-color mt-1 custom-color" type="color" value="#ffffff">
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? `` : ` style="display: none;"`) + `>
                                <input class="interval-min form-control" placeholder="min">
                            </div>
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? `` : ` style="display: none;"`) + `>
                                <input class="interval-max form-control" placeholder="max">
                            </div>
                        </div>`;

                $($(evt.target).parent().parent().children()[$(evt.target).parent().parent().children().length - 2]).after(intervalRowTemplate);

                let createdIntervals = $('.interval-row');

                let createdInterval = $(createdIntervals[createdIntervals.length - 1]);
                let previousInterval = $(createdIntervals[createdIntervals.length - 2]);

                createdInterval.find('.interval-min').kendoNumericTextBox({});
                createdInterval.find('.interval-max').kendoNumericTextBox({});

                createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                createdInterval.find('input.interval-max').attr('placeholder', 'auto');

                previousInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(false);
                previousInterval.find('input.interval-max').attr('placeholder', 'max');
            }
        });
    }

    _generateIntervals(colors, count) {
        let result = [];

        let remaining = count - colors.length;

        let shades = [];

        for (let i = 0; i < colors.length - 1; i++) {
            shades.push(0);
        }

        for (let i = 0; i < remaining; i++) {
            shades[i % shades.length]++;
        }

        result.push({ min: null, max: null, color: colors[0] });

        for (let i = 1; i < colors.length; i++) {
            let firstColor = colors[i - 1];
            let secondColor = colors[i];

            if (shades[i - 1] > 0) {
                let generated = this._generateColor(firstColor, secondColor, shades[i - 1] + 1).reverse();

                for (let j = 1; j < generated.length; j++) {
                    result.push({ min: null, max: null, color: generated[j] });
                }
            }

            result.push({ min: null, max: null, color: secondColor });
        }

        return result;
    }

    _generateColor(colorStart, colorEnd, colorCount) {
        var start = this._convertToRGB(colorStart);
        var end = this._convertToRGB(colorEnd);
        var len = colorCount;
        var alpha = 0.0;

        var saida = [];

        for (let i = 0; i < len; i++) {
            var c = [];
            alpha += (1.0 / len);

            c[0] = start[0] * alpha + (1 - alpha) * end[0];
            c[1] = start[1] * alpha + (1 - alpha) * end[1];
            c[2] = start[2] * alpha + (1 - alpha) * end[2];

            saida.push('#' + this._convertToHex(c));

        }

        return saida;
    }

    _convertToRGB(hex) {
        var color = [];
        color[0] = parseInt((this._trim(hex)).substring(0, 2), 16);
        color[1] = parseInt((this._trim(hex)).substring(2, 4), 16);
        color[2] = parseInt((this._trim(hex)).substring(4, 6), 16);
        return color;
    }

    _trim(s) {
        return (s.charAt(0) == '#') ? s.substring(1, 7) : s
    }

    _convertToHex(rgb) {
        return this._hex(rgb[0]) + this._hex(rgb[1]) + this._hex(rgb[2]);
    }

    _hex(c) {
        var s = "0123456789abcdef";
        var i = parseInt(c);

        if (i == 0 || isNaN(c))
            return "00";

        i = Math.round(Math.min(Math.max(0, i), 255));
        return s.charAt((i - i % 16) / 16) + s.charAt(i % 16);
    }

    _getTemplate() {
        return `<div class="form-group col-12">
                    <div class="form-row">
                        <div class="col-6" id="id-entity-wrapper">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('Entity') + `</label>
                                <div class="form-control" id="` + this.entityId + `"></div>
                            </div>
                        </div>
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('ThematicField') + `</label>
                                <input class="form-control" id="` + this.entityFieldId + `">
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-3">
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('Opacity') + `</label>
                                <input class="form-control" id="` + this.opacityId + `">
                            </div>
                        </div>
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('ClassificationMode') + `</label>
                                <input class="form-control" id="` + this.modeId + `">
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-3">
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('StrokeWidth') + `</label>
                                <input class="form-control" id="` + this.strokeWidthId + `">
                            </div>
                        </div>
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('LabelTemplate') + `</label>
                                <input class="form-control" id="` + this.labelTemplateId + `" type="text">
                            </div>
                        </div>
                    </div>
                    <div id="` + this.graduatedSectionId + `">
                        <div class="form-row mb-3">
                            <div class="col-6 mb-3 align-content-center">
                                <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                                    <label class="form-label ml-1">` + this.resourcesHandler.get('ColorIntervalsAuto') + `</label>
                                    <div id="` + this.valueAutoId + `"></div>
                                </div>
                            </div>
                            <div class="col-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.resourcesHandler.get('ClassificationMethod') + `</label>
                                    <input class="form-control" id="` + this.methodId + `">
                                </div>
                            </div>
                        </div>
                        <div class="form-row ml-0" id="` + this.colorRampContainerId + `">
                        </div>
                        <div class="form-row ml-0 mt-1" id="` + this.colorIntervalContainerId + `">
                        </div>
                    </div>
                    <div id="` + this.categorizedSectionId + `" style="display: none;">
                        <div class="form-row mb-3 ml-0">
                            <button id="` + this.loadCategoriesButtonId + `" class="btn btn-primary" type="button" style="height: 2.25rem;">` + this.resourcesHandler.get('LoadCategories') + `</button>
                            <button id="` + this.randomizeColorsButtonId + `" class="btn btn-secondary ml-2" type="button" style="height: 2.25rem;">` + this.resourcesHandler.get('RandomizeColors') + `</button>
                        </div>
                        <div class="form-row ml-0 mt-1" id="` + this.categoryContainerId + `">
                        </div>
                    </div>
                </div>`;
    }
}
